import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerCaricaFatturaPRModalComponent } from './worker-carica-fattura-pr-modal';

export const WorkerCaricaFatturaPRModalModule: string = ng
    .module('worker-carica-fattura-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerCaricaFatturaPRModalComponent', WorkerCaricaFatturaPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/worker-carica-fattura-pr-modal/worker-carica-fattura-pr-modal.module.ts